// A browser fix vaguer than this is a network guess (no GPS): the server's position is as good or better
const PRECISE_ACCURACY_METERS = 2000;

let _position = null;

const _serverPosition = () => {
    const lat = parseFloat(window.userLatitude);
    const lng = parseFloat(window.userLongitude);
    if (lat && lng) {
        return {center: [lng, lat], precise: false};
    }

    if (window.countryMapCenter) {
        return {center: [window.countryMapCenter[1], window.countryMapCenter[0]], precise: false};
    }

    return null;
};

// The browser's own timeout only runs once the prompt is answered: an ignored prompt never calls back
const BROWSER_POSITION_TIMEOUT_MS = 8000;

const _browserPosition = () => new Promise((resolve) => {
    if (!navigator.geolocation) {
        resolve(null);

        return;
    }

    setTimeout(() => resolve(null), BROWSER_POSITION_TIMEOUT_MS);

    navigator.geolocation.getCurrentPosition(
        ({coords}) => resolve(coords.accuracy <= PRECISE_ACCURACY_METERS ? {center: [coords.longitude, coords.latitude], precise: true} : null),
        () => resolve(null),
        {timeout: 8000, maximumAge: 600000}
    );
});

// One position for every "around me" search of the session: {center: [lng, lat], precise} or null
export const resolveUserPosition = async () => {
    if (!_position) {
        _position = (await _browserPosition()) || _serverPosition();
    }

    return _position;
};

export const resetUserPosition = () => {
    _position = null;
};
